import React from 'react';
import { Gamepad2, Twitter, Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-pinnacle-dark pt-20 pb-10 border-t border-pinnacle-border" data-id="element-30">
      <div className="container mx-auto px-4" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-32">
          <div className="col-span-1 md:col-span-1" data-id="element-33">
            <div className="flex items-center gap-2 mb-6" data-id="element-34">
              <Gamepad2 className="w-8 h-8 text-pinnacle-green" data-id="element-35" />
              <span className="text-2xl font-bold text-white font-display" data-id="element-36">
                PinnacleGames
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-37">
              The definitive source for game ratings. We aggregate reviews from
              across the web to help you decide what to play next.
            </p>
            <div className="flex gap-4" data-id="element-38">
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-39">
                <Twitter size={20} data-id="element-40" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-41">
                <Facebook size={20} data-id="element-42" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-43">
                <Instagram size={20} data-id="element-44" />
              </a>
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-45">
                <Youtube size={20} data-id="element-46" />
              </a>
            </div>
          </div>

          <div data-id="element-47">
            <h4 className="text-white font-bold mb-6" data-id="element-48">Platform</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-49">
              <li data-id="element-50">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-51">
                  Browse Games
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-53">
                  Top Lists
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-55">
                  New Releases
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-57">
                  Coming Soon
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-58">
            <h4 className="text-white font-bold mb-6" data-id="element-59">Company</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-60">
              <li data-id="element-61">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-62">
                  About Us
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-64">
                  Our Methodology
                </a>
              </li>
              <li data-id="element-65">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-66">
                  Careers
                </a>
              </li>
              <li data-id="element-67">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-68">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-69">
            <h4 className="text-white font-bold mb-6" data-id="element-70">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-71">
              <li data-id="element-72">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-73">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-75">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-76">
                <a href="#" className="hover:text-pinnacle-green transition-colors" data-id="element-77">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-pinnacle-border flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-78">
          <div data-id="element-79">© 2026 PinnacleGames. All rights reserved.</div>
          <div className="flex items-center gap-6" data-id="element-80">
            <span data-id="element-81">Limassol, Cyprus</span>
          </div>
        </div>
      </div>
    </footer>;
}